import { useEffect, useState } from "react";

const TrimmedImage = ({ src, alt, style }) => {
    const [trimmed, setTrimmed] = useState(null);

    useEffect(() => {
        if (!src) return;
        let cancelled = false;
        const img = new Image();

        img.onload = () => {
            try {
                const canvas = document.createElement("canvas");
                canvas.width = img.naturalWidth;
                canvas.height = img.naturalHeight;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                const { data, width, height } = ctx.getImageData(0, 0, canvas.width, canvas.height);

                let minX = width, minY = height, maxX = -1, maxY = -1;
                for (let y = 0; y < height; y++) {
                    for (let x = 0; x < width; x++) {
                        const i = (y * width + x) * 4;
                        const isInk = data[i + 3] > 20 && (data[i] < 200 || data[i + 1] < 200 || data[i + 2] < 200);
                        if (isInk) {
                            if (x < minX) minX = x;
                            if (y < minY) minY = y;
                            if (x > maxX) maxX = x;
                            if (y > maxY) maxY = y;
                        }
                    }
                }

                if (maxX < 0) {
                    if (!cancelled) setTrimmed(src);
                    return;
                }

                const pad = 4;
                minX = Math.max(0, minX - pad);
                minY = Math.max(0, minY - pad);
                maxX = Math.min(width - 1, maxX + pad);
                maxY = Math.min(height - 1, maxY + pad);

                const out = document.createElement("canvas");
                out.width = maxX - minX + 1;
                out.height = maxY - minY + 1;
                out.getContext("2d").drawImage(canvas, minX, minY, out.width, out.height, 0, 0, out.width, out.height);

                if (!cancelled) setTrimmed(out.toDataURL("image/png"));
            } catch (e) {
                if (!cancelled) setTrimmed(src);
            }
        };

        img.onerror = () => {
            if (!cancelled) setTrimmed(src);
        };

        img.src = src;
        return () => { cancelled = true; };
    }, [src]);

    return <img src={trimmed || src} alt={alt} style={style} />;
};

export default TrimmedImage;